import DataCard from 'components/data-card/data-card.component';
import { useSearchQueryContext } from 'components/search/search.hooks';

type SummaryCardBoundaryProps = {
  children: React.ReactNode;
  queryName: string;
  expectedCount: number;
};

const SummaryCardBoundary = ({
  children,
  queryName,
  expectedCount,
}: SummaryCardBoundaryProps) => {
  const {
    data,
    queryState: { isFetching, isError },
  } = useSearchQueryContext(queryName);

  if (isFetching)
    return Array.from({ length: expectedCount }).map((_, index) => (
      <DataCard key={`loading-${index}`} loading />
    ));

  if (isError)
    return Array.from({ length: expectedCount }).map((_, index) => (
      <DataCard key={`isError-${index}`} isError />
    ));

  return !!data ? children : null;
};

export default SummaryCardBoundary;
